import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

export const dataServiceFactory = (client: HttpClient) =>
  new DataService(client);

// THIS CLASS CAN BE USE AS A WRAPPER TO THE HTTP CLIENT
// WE CAN ADD HEADERS IN HERE, CHECK FOR TOKENS, ETC
@Injectable()
export class DataService {
  private httpGlobalOptions = {
    responseType: 'json',
  };

  constructor(private client: HttpClient) {}

  public get<T>(
    url: string,
    query = {},
    headers?: HttpHeaders | { [header: string]: string | string[] },
    doNotEncode?: boolean,
    responseType?: string
  ): Observable<T> {
    const q = this.transformToNOUrlencoded(query);

    const conf = this.getConf({
      method: 'get',
      url: doNotEncode === true ? `${url}?${q}` : url,
      params: doNotEncode === true ? '' : query,
      headers,
      responseType: responseType
        ? responseType
        : this.httpGlobalOptions.responseType,
    });
    return this.request<T>(conf);
  }

  public getDataByLazyLoading(url: string, query: any): Observable<any> {
    const q = this.transformToNOUrlencoded(query);
    return this.client.get(`${url}?${q}`);
  }

  public getWalkListProgress(url: string, query: any): Observable<any> {
    const q = this.transformToNOUrlencoded(query);
    return this.client.get<any>(`${url}?${q}`);
  }

  public getPlainRequest<T>(
    url: string,
    headers: HttpHeaders | { [header: string]: string | string[] }
  ) {
    const conf = this.getConf({
      method: 'GET',
      url: `${url}`,
      headers,
    });

    return this.request(conf);
  }

  public post<T>(
    url: string,
    data: T,
    headers?: HttpHeaders | { [header: string]: string | string[] },
    params?: any
  ): Observable<T> {
    const conf = this.getConf({
      method: 'POST',
      url,
      body: data,
      params,
    });

    if (headers) {
      conf['headers'] = headers;
    }

    return this.request<T>(conf);
  }

  public postDTO<T, G>(url: string, data: G, params?: any): Observable<T> {
    const conf = this.getConf({
      method: 'post',
      url,
      body: data,
      params,
    });

    return this.request<T>(conf);
  }

  public put<T>(
    url: string,
    data: T,
    headers?: HttpHeaders | { [header: string]: string | string[] },
    params?: any
  ): Observable<T> {
    const conf = this.getConf({
      method: 'put',
      url,
      body: data,
      params,
    });

    if (headers) {
      conf['headers'] = headers;
    }

    return this.request<T>(conf);
  }

  public delete<T>(url: string): Observable<T> {
    const conf = this.getConf({
      method: 'DELETE',
      url,
    });

    return this.request<T>(conf);
  }

  private getConf(conf = {}) {
    return Object.assign({}, this.httpGlobalOptions, conf);
  }

  private request<T>(request): Observable<any> {
    return this.client.request<T>(request.method, request.url, request);
  }

  private transformToNOUrlencoded = <T>(object: T | string): string => {
    if (typeof object === 'string') {
      return object.toString();
    }

    if (!object) {
      return '';
    }

    return (
      Object.keys(object)
        .map((key) => `${key}=${object[key]}`)
        .join('&') || ''
    );
  };
}
